import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import AnalysisReport from "@/components/AnalysisReport";
import ValidationReport from "@/components/ValidationReport";
import { Loader2, ArrowLeft, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ReportView() {
  const { id } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/my/reports/${id}`).then((r) => setReport(r.data)).catch(() => setError(true));
  }, [id]);

  if (error) return <div className="min-h-[60vh] flex items-center justify-center text-slate-400">Report not found.</div>;
  if (!report) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="w-8 h-8 text-cyan-400 animate-spin" /></div>;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-center justify-between mb-6">
        <Link to="/dashboard" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-cyan-300"><ArrowLeft className="w-4 h-4" />Workspace</Link>
        <Button variant="ghost" onClick={() => { navigator.clipboard.writeText(window.location.href); toast.success("Link copied"); }} className="text-slate-400"><Share2 className="w-4 h-4 mr-1.5" />Share</Button>
      </div>
      <h1 className="font-display text-2xl sm:text-3xl font-extrabold text-slate-50 mb-6">
        {report.type === "analysis" ? "Opportunity Intelligence Report" : "Idea Validation Report"}
        <span className="block text-base font-normal text-slate-400 mt-1">{report.opportunity_title || report.title}</span>
      </h1>
      {report.type === "analysis" ? <AnalysisReport report={report.report} /> : <ValidationReport report={report.report} />}
    </div>
  );
}
